export const isHttps = window.location.protocol.includes('https')